import apiUrl from 'common/api-url';
import { xhr } from 'common/xhr';

export type QuoteType = 'CREATED' | 'VOID';

export type ActiveQuote = {
  quoteId: number;
  venueQuoteNumber: number;
  venueId: number;
  type: QuoteType;
};

export type LatestActiveQuote = ActiveQuote;

type FetchLatestActiveQuoteParams = {
  venueCustomerId: number;
  appointmentDate: string;
};

/**
 * Fetches the latest active (CREATED) quote for a given customer on a given date.
 * Returns null when no active quote exists or on any error.
 */
export function fetchLatestActiveQuote({
  venueCustomerId,
  appointmentDate,
}: FetchLatestActiveQuoteParams): JQueryPromise<LatestActiveQuote | null> {
  const url = apiUrl('POS_QUOTES', { venueCustomerId, date: appointmentDate, status: 'CREATED' });
  return xhr
    .getWithPromise(url)
    .then((data: Array<{ quoteId: number; venueQuoteNumber: number; venueId: number }>) => {
      if (!data.length) return null;
      const { quoteId, venueQuoteNumber, venueId } = data[0];
      return { quoteId, venueQuoteNumber, venueId, type: 'CREATED' as const };
    })
    .fail(() => null);
}
